<template>
    <section>
        <h2 class="text-center">My Colleagues</h2>
        <table class="table table-striped table-bordered">
            <thead>
                <tr>
                    <th>Name</th>
                    <th>Status</th>
                    <th>Job Title</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="colleague in colleagues" :key="colleague.id">
                    <td>{{ colleague.full_titled_name }}</td>
                    <td><span :class="'label ' + colleague.status_class">{{ colleague.status_text }}</span></td>
                    <td>{{ colleague.job_title }}</td>
                </tr>
            </tbody>
        </table>
    </section>
</template>

<style lang="scss" scoped>
tbody tr td {
    padding: 1rem;
}
</style>

<script>
import Api from "@/Api";

export default {
    data() {
        return {
            colleagues: {},
        };
    },
    methods: {
        getColleaguesData() {
            Api()
                .get("auth/get-colleagues")
                .then((res) => {
                    this.colleagues = res.data.colleagues;
                    this.mapColleagues();
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        mapColleagues() {
            this.colleagues = this.colleagues.filter((colleague) => {
                return [1, 2].includes(colleague.conferences_clients[0].status);
            })
            this.colleagues = this.colleagues.map((colleague) => {
                let conferenceClient = colleague.conferences_clients[0],
                    statusClass,
                    statusText;

                switch (conferenceClient.status) {
                    case 1:
                        statusClass = "label-warning";
                        statusText = "Not registered";
                        break;
                    case 2:
                        statusClass = "label-success";
                        statusText = "Registered";
                        break;
                    default:
                        statusClass = "label-danger";
                        statusText = "Rejected";
                        break;
                }

                return {
                    ...colleague,
                    status_text: statusText,
                    status_class: statusClass,
                };
            });
        },
    },
    created() {
        this.getColleaguesData();
    },
};
</script>
